// extracted by mini-css-extract-plugin
export var bbottom = "footer-module--bbottom--71e13";
export var brandCol = "footer-module--brandCol--3d86a";
export var brandDesc = "footer-module--brandDesc--07c9a";
export var brandName = "footer-module--brandName--9d65a";
export var btop = "footer-module--btop--3fc30";
export var copyright = "footer-module--copyright--b1046";
export var dfooter = "footer-module--dfooter--52f45";
export var footer = "footer-module--footer--42660";
export var footerBottom = "footer-module--footerBottom--d58fa";
export var footerEmailBtn = "footer-module--footerEmailBtn--8c42c";
export var footerEmailForm = "footer-module--footerEmailForm--7df01";
export var footerEmailInput = "footer-module--footerEmailInput--93b8b";
export var footerFormDone = "footer-module--footerFormDone--b3050";
export var footerTagline = "footer-module--footerTagline--aa4ae";
export var h5 = "footer-module--h5--33d07";
export var socialIcons = "footer-module--socialIcons--b1645";